module.exports = __webpack_public_path__ + "img/鎏金面膜+珍银面膜_07.9307f39e.jpg";